// extracted by mini-css-extract-plugin
export default {"page":"HackworkPage_page__cmcIA","page__header":"HackworkPage_page__header__K0wTG","page__title":"HackworkPage_page__title__MBZ+P"};